export const orgLevelNameFromType = (type) => {
    let components = type.split(/(?=[A-Z])|-/);

    components = components.map(component => {
        component.replace('-', '');  // remove the dash
        return component.charAt(0).toUpperCase() + component.slice(1) // capitalize the first letter
    });

    return components.join(" ");
};

export const makeTypeSingular = (type) => {
    return type.endsWith('s') ? type.slice(0, -1) : type;
}